export const ADMIN = 'admin'
export const USER = 'user'
export const SUPPORT = 'support'

// Role-ready staff specialisations (Dashboard Redesign, Phase 5). Defined here
// so the nav/landing structure can adapt to them; assigning these requires
// matching backend support (User.userType enum + restrictTo). Until then only
// ADMIN/SUPPORT are actually issued, and these are inert.
// DAM asset contributor — mobile capture only (backend: userType 'shopper',
// assetPermissions default ['assets.upload']).
export const SHOPPER = 'shopper'
export const OPERATIONS = 'operations'
export const GROWTH = 'growth'

// Where each role lands after sign-in (used by views/index.js). Anything not
// listed falls back to the app's authenticatedEntryPath.
export const ROLE_LANDING = {
    [SUPPORT]: '/app/sales/support-list',
    [SHOPPER]: '/app/assets/capture',
    [OPERATIONS]: '/app/sales/order-list',
    [GROWTH]: '/app/analytics/live-visitors',
}
